import { INVALID_FILES_ERROR } from "./types";

export const invalidFilesError = (invalidFiles) => ({
  type: INVALID_FILES_ERROR,
  payload: invalidFiles,
});
